<!--
 * @Description: 标准设置
 * @Autor: yjx
 * @Date: 2021-11-17 11:54:54
 * @LastEditors: yjx
 * @LastEditTime: 2021-11-17 11:54:54
-->
<template>
    <el-dialog title="标准设置" :visible="visible" width="400px" @close="onClose" @open="onOpen" @closed="onClosed">
        <el-form ref="inputForm" :model="inputForm" :rules="inputRules" label-width="100px" class="input_form">
            <el-form-item label="合格标准：" prop="hgbz">
                <span class="left">[</span>
                <el-input
                    v-model="inputForm.hgbz[0]"
                    type="number"
                    placeholder="下限值"
                />
                <span class="center">，</span>
                <el-input
                    v-model="inputForm.hgbz[1]"
                    type="number"
                    placeholder="上限值"
                />
                <span class="right">]</span>
            </el-form-item>
            <el-form-item label="异常标准：" prop="ycbz">
                <div class="left">(</div>
                <el-input
                    v-model="inputForm.ycbz[0]"
                    type="number"
                    placeholder="下限值"
                />
                <div class="center">，</div>
                <el-input
                    v-model="inputForm.ycbz[1]"
                    type="number"
                    placeholder="上限值"
                />
                <div class="right">)</div>
            </el-form-item>
            <el-form-item label="异常标准2：" prop="ycbz2">
                <div class="left">(</div>
                <el-input
                    v-model="inputForm.ycbz2[0]"
                    type="number"
                    placeholder="下限值"
                />
                <div class="center">，</div>
                <el-input
                    v-model="inputForm.ycbz2[1]"
                    type="number"
                    placeholder="上限值"
                />
                <div class="right">)</div>
            </el-form-item>
        </el-form>

        <span slot="footer" class="dialog-footer">
            <el-button class="bottom_all_two" @click="onClose">取 消</el-button>
            <el-button class="bottom_all" type="primary" @click="onConfirm"
                >确 定</el-button
            >
        </span>
    </el-dialog>
</template>

<script>
export default {
    data() {
        return {
            inputForm: {
                hgbz: [], // 合格标准
                ycbz: [], // 异常标准
                ycbz2: [], // 异常标准2
            },
            inputRules: {
                hgbz: [{ required: true, message: '请输入合格标准' }],
                ycbz: [{ required: true, message: '请输入异常标准' }],
                ycbz2: [{ required: true, message: '请输入异常标准2' }],
            },
        }
    },
    props: {
        config: {
            type: Object,
            default: () => {},
        },
        visible: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        onOpen() {
            // 打开弹框
            if (this.$refs.inputForm) this.$refs.inputForm.clearValidate();
            this.inputForm = this.config.data.hgbz ? this.config.data : { hgbz: [], ycbz: [], ycbz2: [] }
        },
        onClose() {
            // 关闭弹框
            this.$emit('update:visible', false)
        },
        onClosed() {
            // 关闭结束的回调，清空数据，清除校验
            this.inputForm = {
                hgbz: [], // 合格标准
                ycbz: [], // 异常标准
                ycbz2: [], // 异常标准
            }
        },
        onConfirm() {
            // 确定
            if (this.config.type === 'input') {
                const [hgbz1, hgbz2] = this.inputForm.hgbz
                const [ycbz1, ycbz2] = this.inputForm.ycbz
                const [ycbz21, ycbz22] = this.inputForm.ycbz2
                if (!hgbz1 || !hgbz2) {
                    return this.$refs.inputForm.validateField('hgbz')
                } else {
                    this.$refs.inputForm.clearValidate(['hgbz'])
                }
                if (!ycbz1 || !ycbz2) {
                    return this.$refs.inputForm.validateField('ycbz')
                } else {
                    this.$refs.inputForm.clearValidate(['ycbz'])
                }
                if (!ycbz21 || !ycbz22) {
                    return this.$refs.inputForm.validateField('ycbz2')
                } else {
                    this.$refs.inputForm.clearValidate(['ycbz2'])
                }
            }
            for (const key in this.inputForm) {
                for (let i = 0; i < this.inputForm[key].length; i++) {
                    this.inputForm[key][i] = Number(this.inputForm[key][i])
                }
            }
            const params = { data: this.inputForm, key: this.config.key }
            this.$emit('updated', params)
            this.$emit('update:visible', false)
        },
    },
}
</script>

<style lang="scss">
.input_form {
    .left {
        margin-right: 10px;
    }
    .center {
        margin: 0 10px;
    }
    .right {
        margin-left: 10px;
    }
    .el-form-item__content {
        display: flex;
    }
    .el-input_inner {
        width: 50px;
    }
}
</style>
